// The reader's moves in the opening, each with the app's one grade
// (`GameScan.grade`: the user's rules decide blunder and miss, the scan's
// fixed steps the rest), and where the game left the opening book and who
// left it. What a game's "Score through the opening" draws as a strip.
// 2026-10-10: each move also carries the position after it, which the
// "Your moves" card names from the book.
import type { GameFacts, GradedMove } from '@chess/api-model';
import type { FactExtractor, ScannedGame } from '../extractor.ts';

export const openingMoves: FactExtractor = {
  id: 'opening-moves',
  extract(game: ScannedGame, facts: GameFacts): void {
    const { fromPly, toPly } = game.range('opening');
    const out: GradedMove[] = [];
    for (let ply = fromPly + 1; ply <= toPly; ply++) {
      const move = game.moves[ply - 1];
      if (!move || !game.isReaders(ply)) continue;
      const grade = game.judge.grade(ply, move, game.reader);
      if (!grade) continue;
      const graded: GradedMove = { ply, san: move.san, grade };
      const fen = game.at(ply)?.fen;
      if (fen) graded.fen = fen;
      out.push(graded);
    }
    facts.openingMoves = out;
    const { lastKnownPly, leftBy } = game.phases;
    if (lastKnownPly !== undefined && leftBy && lastKnownPly < game.moves.length) facts.bookExit = { ply: lastKnownPly + 1, by: leftBy };
  },
};
